<template>
    <div v-if="showPopup" class="overlay"></div>
    <div v-if="showPopup" class="popup-container">
        <h3 class="title">{{ getTranslatedText('event expired') }}</h3>
        <ButtonCommon text="refresh" class="button__primary" :isDisable="isDisableAddButton" @action="refreshPage" />
    </div>
</template>
  
<script>
import languageMixins from "@/mixins/language-mixins";
import ButtonCommon from "@/components/common/button";
export default {
    mixins: [languageMixins],
    components: { ButtonCommon },
    props: {
        showPopup: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        refreshPage() {
            this.$emit("refreshPage");
        },
    },
};
</script>
  
<style lang="scss" scoped>
@import "@/public/scss/common/popup/refresh-page.scss";
</style>
  